/**
 * useVisibility — returns the current Page Visibility state as a React boolean.
 *
 * Sprint B Fix 11.
 * Components that poll the backend on a `setInterval` should include this
 * boolean in their effect dependency array and short-circuit (`if (!isVisible) return`)
 * so the interval is torn down while the tab is hidden and re-installed when the
 * tab becomes visible again. This eliminates background polling traffic per
 * open tab without changing any polling intervals or behavior.
 *
 * Safe in SSR / non-browser environments — defaults to `true`.
 */
import { useEffect, useState } from "react";

const getInitialVisibility = () => {
  if (typeof document === "undefined") return true;
  return !document.hidden;
};

export function useVisibility() {
  const [isVisible, setIsVisible] = useState(getInitialVisibility);

  useEffect(() => {
    if (typeof document === "undefined") return undefined;

    const handler = () => setIsVisible(!document.hidden);

    document.addEventListener("visibilitychange", handler);
    return () => document.removeEventListener("visibilitychange", handler);
  }, []);

  return isVisible;
}

export default useVisibility;
